import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ButtonGroup
} from '@material-ui/core';

import AddSection from './components/AddSection';
import api from 'services/api';
import { useParams } from 'react-router-dom';
import DeleteSection from './components/DeleteSection';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const SectionList = props => {
  const { className, field, ...rest } = props;
  const [list, setList] = useState([]);
  const { id } = useParams();

  const classes = useStyles();

  const fetchList = useCallback(async () => {
    if(!field) {
      return;
    }

    try {
      const response = await api.get(`plannings/${id}/seedstreatments?field_id=${field}`);

      setList(response.data);
    } catch (err) {
      console.log(err);
      alert('Erro ao carregar os dados');
    }
  }, [id, field]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={
          <AddSection field={field} onFetch={fetchList} />
        }
        title="Tratamento de sementes"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Produto</TableCell>
                  <TableCell>Dose</TableCell>
                  <TableCell>Volume</TableCell>
                  <TableCell align="right">Opções</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map(item => (
                  <TableRow
                    hover
                    key={item.id}
                  >
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item?.product.name}</TableCell>
                    <TableCell>{item?.dose}</TableCell>
                    <TableCell>{item?.volume}</TableCell>
                    <TableCell align="right">
                      <ButtonGroup size="small">
                        <DeleteSection seed_treatment_id={item.id} onFetch={fetchList} />
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

SectionList.propTypes = {
  className: PropTypes.string
};

export default SectionList;
